import { render, staticRenderFns } from "./byTwoIndex.vue?vue&type=template&id=7c22fd9e"
import script from "./byTwoIndex.vue?vue&type=script&lang=js"
export * from "./byTwoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports